import React from 'react';

let withField = Cmp => {
  return props => {
    const { input, meta, ...cmpProps } = props;
    return <Cmp {...input} {...cmpProps} />;
  };
};

export default withField;



// WEBPACK FOOTER //
// ./src/decorators/with-field.js